// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--zKBIn","fullWidth":"fullWidth--u0gor","narrow":"narrow--mddaH","extra-narrow":"extra-narrow--cfIHh","extraNarrow":"extra-narrow--cfIHh"};